/**
 * KPIBlock — the data contract for KPI metric card components.
 *
 * This is a pure TypeScript file with zero framework imports.
 * Backend tool schemas (Zod) should mirror these types.
 */

export interface KPITrend {
  direction: 'up' | 'down' | 'flat';
  value: number;
  label?: string;
  sentiment?: 'positive' | 'negative' | 'neutral';
}

export interface KPIMetric {
  label: string;
  value: number;
  format?: 'number' | 'currency' | 'percent' | 'compact';
  trend?: KPITrend;
}

export interface KPIBlock {
  metrics: KPIMetric[];
}

export function isValidKPIBlock(data: unknown): data is KPIBlock {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  if (!Array.isArray(d.metrics) || d.metrics.length === 0) return false;
  return d.metrics.every(
    (m: unknown) =>
      m &&
      typeof m === 'object' &&
      typeof (m as Record<string, unknown>).label === 'string' &&
      typeof (m as Record<string, unknown>).value === 'number'
  );
}
